import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { portalUserService } from '../../services';
import { DASHBOARD_MULTI_COMPANY_LOCAL_STORAGE_KEY } from './Dashboard.utils';

interface DashboardMultiCompanyContextType {
    selectedCompanyId: number | null;
    setSelectedCompanyId: (id: number) => void;
}

const defaultContext: DashboardMultiCompanyContextType = {
    selectedCompanyId: null,
    setSelectedCompanyId: () => {},
};

const DashboardMultiCompanyContext = createContext<DashboardMultiCompanyContextType>(defaultContext);

interface DashboardMultiCompanyProviderProps {
    children: ReactNode;
}

export const DashboardMultiCompanyProvider: React.FC<DashboardMultiCompanyProviderProps> = ({ children }) => {
    const currentCompanyId = portalUserService.getCurrentCompanyId();
    const storedCompanyId = localStorage.getItem(DASHBOARD_MULTI_COMPANY_LOCAL_STORAGE_KEY);

    const [selectedCompanyId, setSelectedCompanyId] = useState<number>(
        storedCompanyId ? Number(storedCompanyId) : currentCompanyId
    );

    // Sync with local storage
    useEffect(() => {
        localStorage.setItem(DASHBOARD_MULTI_COMPANY_LOCAL_STORAGE_KEY, selectedCompanyId.toString());
    }, [selectedCompanyId]);

    // Sync with portalUserService
    useEffect(() => {
        portalUserService.setMultipleCompanyChildrenSelection([selectedCompanyId]);
    }, [selectedCompanyId]);

    return (
        <DashboardMultiCompanyContext.Provider value={{ selectedCompanyId, setSelectedCompanyId }}>
            {children}
        </DashboardMultiCompanyContext.Provider>
    );
};

export const useDashboardMultiCompany = (): DashboardMultiCompanyContextType => {
    return useContext(DashboardMultiCompanyContext);
};
